import { createSelector } from 'reselect';
import { GetNavigationConfiguration } from './operations';

export const getDashboardLoading = createSelector(
  state => state.dashboard?.isLoading,
  isLoading => isLoading
);

export const getDashboardError = createSelector(
  state => state.dashboard?.isError,
  isError => isError
);

export const getDashboard = createSelector(
  state => state.dashboard,
  dashboard => dashboard
);

export const getDashboardOrderSummary = createSelector(
  state => state?.dashboard?.orderSummary,
  orderSummary => orderSummary
);

export const getIsPurchasable = createSelector(
  state => state.dashboard?.status?.unpurchasable,
  unpurchasable => !unpurchasable
);

export const getNavigationConfig = createSelector(
  state => state?.dashboard?.status?.orderState,
  state => state?.dashboard?.status?.steps,
  state => state?.dashboard?.availableOptions?.needsToScheduleTimeSlot,
  state => state?.dashboard?.experiments,
  state => state?.dashboard?.vehicleLock?.isAvailable,
  (orderState, steps, needsToScheduleTimeSlot, experiments, isAvailable) =>
    GetNavigationConfiguration(
      orderState,
      steps,
      needsToScheduleTimeSlot,
      experiments,
      isAvailable
    )
);

export const getOrderState = createSelector(
  state => state.dashboard?.status?.orderState,
  orderState => orderState?.toLowerCase()
);

export const getOrderId = createSelector(
  state => state.dashboard?.status?.orderId,
  orderId => orderId
);

export const getUserId = createSelector(
  state => state?.core?.userId,
  userId => userId
);

export const getPurchaseId = createSelector(
  state => state?.dashboard?.status?.purchaseId,
  purchaseId => purchaseId
);

export const getStockNumber = createSelector(
  state => state?.vehicle?.stockNumber,
  stockNumber => stockNumber
);

export const getVehiclePrice = createSelector(
  state => state?.vehicle?.price,
  vehiclePrice => vehiclePrice
);

export const getNeedsToScheduleTimeSlot = createSelector(
  state => state?.dashboard?.availableOptions?.needsToScheduleTimeSlot,
  needsToScheduleTimeSlot => needsToScheduleTimeSlot
);

export const getPurchaseExperiments = createSelector(
  state => state.dashboard?.experiments,
  experiments => {
    return experiments || {};
  }
);

export const getPurchaseHeaderExperiment = createSelector(
  state => state.core.experiments,
  experiments =>
    experiments.some(
      experiment =>
        experiment.experimentKey === 'pp-purchase-header-dec-2023' &&
        experiment.bucketKey === 'purchase-header'
    )
);

export const getDashboardSteps = createSelector(
  state => state?.dashboard?.status?.steps,
  steps => {
    const stepsArray = [];
    if (!steps) return steps;
    const keys = Object.keys(steps);
    keys.forEach(x => {
      stepsArray.push({
        name: x,
        ...steps[x]
      });
    });

    return stepsArray;
  }
);

export const getIsLockTimerPaused = createSelector(
  state =>
    state.dashboard?.vehicleLock?.IsPaused ||
    (state.dashboard?.vehicleLock?.expiresOn &&
      new Date(state.dashboard?.vehicleLock?.expiresOn).getYear() >
        new Date().getYear() + 10),
  IsPaused => IsPaused
);

export const getPaymentSummary = createSelector(
  state => state?.dashboard?.paymentSummary,
  paymentSummary => paymentSummary
);
